var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "formData" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c("form-create-designer", {
            ref: "designer",
            attrs: { condition: _vm.$store.state.business.conditionsFields },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }